import { render, staticRenderFns } from "./ListarRelatoriosUsuariosView.vue?vue&type=template&id=2e63c4be&scoped=true&"
import script from "./ListarRelatoriosUsuariosView.vue?vue&type=script&lang=js&"
export * from "./ListarRelatoriosUsuariosView.vue?vue&type=script&lang=js&"
import style0 from "./ListarRelatoriosUsuariosView.vue?vue&type=style&index=0&id=2e63c4be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e63c4be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VChip,VChipGroup,VCol,VContainer,VDataTable,VForm,VIcon,VRow,VSelect,VTextField})
